// ** Sentry - DEVE ser importado ANTES de qualquer outro código
import { initSentry } from './configs/sentryConfig'

// ** React Imports
import { Suspense, lazy, useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom'

// ** Redux Imports
import { store, persistor } from './redux/store'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'

// ** Intl, CASL & ThemeColors Context
import ability from './configs/acl/ability'
import { AbilityContext } from './utility/context/Can'
import { ThemeContext } from './utility/context/ThemeColors'

// ** ThemeConfig
import themeConfig from './configs/themeConfig'

// ** Toast
import { Toaster } from 'react-hot-toast'

// ** i18n
import './configs/i18n'

// ** Spinner (Splash Screen)
import Spinner from './@core/components/spinner/Fallback-spinner'

// ** Ripple Button
import './@core/components/ripple-button'

// ** Fake Database (Comentado temporariamente para testes de API)
// import './@fake-db'

// ** PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import 'prismjs/components/prism-jsx.min'

// ** React Perfect Scrollbar
import 'react-perfect-scrollbar/dist/css/styles.css'

// ** React Hot Toast Styles
import '@styles/react/libs/react-hot-toasts/react-hot-toasts.scss'

// ** Core styles
import './@core/assets/fonts/feather/iconfont.css'
import './@core/scss/core.scss'
import './assets/scss/style.scss'

// ** Service Worker
import * as serviceWorker from './serviceWorker'

// ** API Test Utility (Development only)
if (process.env.NODE_ENV === 'development') {
  import('./utility/apiTest')
}

// ** Lazy load app
const LazyApp = lazy(() => import('./App'))

// ** Sentry ErrorBoundary
import SentryErrorBoundary from './components/SentryErrorBoundary'

const container = document.getElementById('root')
const root = createRoot(container)

// ** Inicializa Sentry de forma assíncrona sem bloquear o render
// Usa setTimeout para garantir que não bloqueie o carregamento inicial
setTimeout(() => {
  initSentry({
    useEffect,
    useLocation,
    useNavigationType,
    createRoutesFromChildren,
    matchRoutes
  }).catch((error) => {
    console.error('Erro ao inicializar Sentry:', error)
  })
}, 0)

root.render(
  <SentryErrorBoundary>
    <BrowserRouter>
      <Provider store={store}>
        <PersistGate loading={<Spinner />} persistor={persistor}>
          <Suspense fallback={<Spinner />}>
            <AbilityContext.Provider value={ability}>
              <ThemeContext>
                <LazyApp />
                <Toaster position={themeConfig.layout.toastPosition} toastOptions={{ className: 'react-hot-toast' }} />
              </ThemeContext>
            </AbilityContext.Provider>
          </Suspense>
        </PersistGate>
      </Provider>
    </BrowserRouter>
  </SentryErrorBoundary>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
